import React, { Component } from 'react'

export class UTCCertificate extends Component {
    render() {
        return (
                <div class="box">
                <div class="box-body">
                    <div class="box-header">
                        <h3 class="box-title">UTC Certificate/Form 3A</h3>
                    </div>
                    <h1 class='text-center'>Please complete 100% Progress before entering UTC Certificate details</h1>
                    <div class="col-md-12">
                        <h3 class="text-center">UTC Certificate</h3>
                        <form action="partworksdetails/utccertificate">
                            <div class="col-md-3" >
                            <div class="form-group">
                                <label>Certificate Issued By</label>
                                <select name="issuedby" class="form-control">
                                    <option value="">Select By</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-md-3">
                            <div class="form-group">
                                <label>Date Of Certificate</label> 
                                <input type="text" placeholder="DD-MM-YYYY" name="utc_date" class="form-control" />
                            </div>
                            </div>
                            <div class="col-md-3">
                            <div class="form-group">
                                <label>Name of Issuing Authority</label> 
                                <input type="text" name="name_of_issuing_auth" class="form-control" />
                            </div>
                            </div>
                            <div class="col-md-2">
                            <div class="form-group">
                                <label>Upload PDF</label> 
                                <input type="file" name="certificatepdf" accept="application/pdf" />
                            </div>
                            </div>
                            <div class="col-md-1" style={{padding: '2.3%'}}>
                            <input type="submit" class="btn btn-primary" value="Save" />
                    </div>
                    </form>	
                </div>
                <div class="col-md-12">
                    <h3 class="text-center">Form 3A</h3>
                    <form action="partworksdetails/utccertificateform3a">
                        <div class="col-md-3" >
                            <div class="form-group">
                            <label>Form 3A Issued By</label>
                            <select name="f_issuedby" class="form-control">
                                <option value="">Select By</option>
                            </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                            <label>Form 3A Date</label> 
                            <input type="text" placeholder="DD-MM-YYYY" name="f_utc_date" class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                            <label>Name of Issuing Authority</label> 
                            <input type="text" name="f_name_of_issuing_auth" class="form-control" />
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group">
                            <label>Upload PDF</label> 
                            <input type="file" name="f_certificatepdf" accept="application/pdf" />
                            </div>
                        </div>
                        <div class="col-md-1" style={{padding: '2.3%'}}>
                        <input type="submit" class="btn btn-primary" value="Save" />
                </div>
                </form>	
                </div>
                </div>
                </div>
        )
    }
}

export default UTCCertificate
